import { Button } from "@commonlibs";
import styled, { css } from "styled-components";

export const ToolbarButton = styled(Button)(
    () => css`
        width: 220px;
    `,
);
